import { render } from "./AttachPhysicianOrder.vue?vue&type=template&id=3dfd0708&ts=true"
import script from "./AttachPhysicianOrder.ts?vue&type=script&lang=ts&external"
export * from "./AttachPhysicianOrder.ts?vue&type=script&lang=ts&external"

import "./AttachPhysicianOrder.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__